import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSharedInboxConfig as GetSharedInboxConfigQuery,
    GetSharedInboxConfig_sharedInboxConfig as SharedInboxConfig,
} from 'nutshell-graphql-types';

import GET_SHARED_INBOX_CONFIG from '../queries/get-shared-inbox-config.graphql';

interface UseGetSharedInboxConfigOptions {
    pollInterval?: number;
}

interface UseGetSharedInboxConfigReturn {
    sharedInboxConfig: SharedInboxConfig | null;
    error: string | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<unknown>;
}

export const useGetSharedInboxConfig = (
    options?: UseGetSharedInboxConfigOptions
): UseGetSharedInboxConfigReturn => {
    const {data, error, loading, refetch} = useQuery<
        GetSharedInboxConfigQuery,
        Record<string, unknown>
    >(GET_SHARED_INBOX_CONFIG, {
        pollInterval: options?.pollInterval,
    });

    const sharedInboxConfig = data?.sharedInboxConfig ?? null;

    return {
        sharedInboxConfig,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
